import { useForceAuth } from "@/store/auth";
import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
  useForceAuth();

  return <Outlet />;
};
